export default __webpack_public_path__ + "35946cdef7f8b74557aa120fec81b8f2.ogg";